<template>
  <Store v-if="loaded" />
  <Loader v-else />
</template>

<script>
import Store from './views/Store';
import Loader from './views/Loader';

export default {
  components: { Loader, Store },
  computed: {
    loaded() {
      return !!this.$store.state.data.loaded;
    },
  },
};
</script>

<style>
.v-application.transparent {
  background-color: rgba(0,0,0,0) !important;
  box-shadow: none !important;
}

.restion-store__footer {
  width: 100%;
  left: 0;
}

.restion-store__sticky-header {
  transition: background-color 0.3s;
  position: sticky;
  top: 0;
  z-index: 5;
}

.restion-store__sticky-title {
  transition: background-color 0.3s;
  position: sticky;
  z-index: 3;
}

.restion-store__sticky-menu {
  transition: background-color 0.3s;
  position: sticky;
  top: 0;
  z-index: 4;
}

.restion-store__sticky-menu-inner {
  /* position:absolute; */
  width:100%;
}

.v-slide-group__wrapper {
  touch-action: auto;
}
.rotate-90 {
  transform: rotate(90deg)
}

.restion-store__button--need_location {
  opacity: 0.8;
}

.v-application .anchor--dark {
  color: rgba(255,255,255,0.9) !important;
  text-underline-offset: 3px;
  text-decoration-color: rgba(255,255,255,0.3) !important;
}

.v-application .anchor--light {
  color: rgba(0,0,0,0.9) !important;
  text-underline-offset: 3px;
  text-decoration-color: rgba(0,0,0,0.3) !important;
}

.height-0 {
  height: 0 !important;
}
</style>
